import { createContext, useContext } from "react";
import { DropzoneInputProps, DropzoneRootProps } from "react-dropzone";
import { noop } from "@common/helpers/function";
import { UploadingDocumentPlaceholder } from "../lib";

export interface FinancialDocumentUploadContextValue {
    isDragActive: boolean;
    inputProps: DropzoneInputProps;
    rootProps: DropzoneRootProps;
    uploadingDocuments: UploadingDocumentPlaceholder[];
    updateUploads(
        cb: (
            prev: UploadingDocumentPlaceholder[],
        ) => UploadingDocumentPlaceholder[],
    ): void;
    clearUploads(): void;
    open(): void;
}

const financialDocumentUploadContext =
    createContext<FinancialDocumentUploadContextValue>({
        isDragActive: false,
        inputProps: {},
        rootProps: {},
        open: noop,
        clearUploads: noop,
        updateUploads: noop,
        uploadingDocuments: [],
    });

export const FinancialDocumentUploadContextProvider =
    financialDocumentUploadContext.Provider;

export function useFinancialDocumentUpload() {
    const ctx = useContext(financialDocumentUploadContext);

    if (!ctx) {
        throw new Error(
            "useFinancialDocumentUpload must be used within a FinancialDocumentUploadProvider",
        );
    }

    return ctx;
}
